var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockcolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 20,
    viewBox: "0 0 683 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 682,
    height: 19,
    rx: 9.5,
    stroke: "#008F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H257C262.523 0 267 4.47715 267 10C267 15.5228 262.523 20 257 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#EF8E21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H112C117.523 0 122 4.47715 122 10C122 15.5228 117.523 20 112 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#C12017"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockcolor);
export default __webpack_public_path__ + "static/media/blockcolor.f8d911dfc20ab1c4497027011e1269db.svg";
export { ForwardRef as ReactComponent };